<template>
  <content-placeholders
    rounded
    class="bg-white p-2 flex flex-col gap-3 rounded-md"
  >
    <div class="grid grid-cols-[80px_1fr] lg:grid-cols-[150px_1fr] gap-3">
      <content-placeholders-img class="!h-36 md:!h-52" />
      <div>
        <content-placeholders-heading />
        <content-placeholders-text />
      </div>
    </div>
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-3">
      <content-placeholders-img class="!h-10" />
      <content-placeholders-img class="!h-10" />
    </div>
  </content-placeholders>
</template>

<script>
export default {};
</script>
